function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-data_svg__a",
  x1: "14.966%",
  x2: "83.867%",
  y1: ".55%",
  y2: "97.802%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#5D9CEC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0E65D7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-data_svg__b",
  x1: "3.349%",
  x2: "100%",
  y1: "41.722%",
  y2: "58.872%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FC6E51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "97.766%",
  stopColor: "#DB391F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-data_svg__c",
  x1: "19.04%",
  x2: "103.238%",
  y1: "34.736%",
  y2: "76.206%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "20%",
  stopColor: "#FFF3BD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "53%",
  stopColor: "#FFE6A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "80%",
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-data_svg__d",
  x1: "4.672%",
  x2: "98.581%",
  y1: "3.349%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FC6E51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "97.766%",
  stopColor: "#DB391F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-data_svg__e",
  x1: "26.908%",
  x2: "89.709%",
  y1: "34.736%",
  y2: "76.206%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "20%",
  stopColor: "#FFF3BD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "53%",
  stopColor: "#FFE6A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "80%",
  stopColor: "#FFD98A"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.37 .243)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 80.251,
  cy: 81.631,
  r: 69.261,
  stroke: "#ABC0D8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.495,
  opacity: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80.251,
  cy: 81.631,
  r: 53.972,
  stroke: "#ABC0D8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.495,
  opacity: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42.352,
  cy: 139.444,
  r: 6.689,
  fill: "#FFF",
  fillRule: "nonzero",
  stroke: "#ABC0D8",
  strokeWidth: 3.495
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.778,
  cy: 124.728,
  r: 4.778,
  stroke: "#155C94",
  strokeWidth: 3.495
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145.422,
  cy: 57.416,
  r: 4.778,
  fill: "#155C94",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDB913",
  fillRule: "nonzero",
  d: "M150.535 5.894l4.257-4.257a1.328 1.328 0 011.879 0l4.257 4.256c.519.52.519 1.36 0 1.879l-4.257 4.258a1.329 1.329 0 01-1.878 0l-4.258-4.258a1.328 1.328 0 010-1.878zM110 157.837l2.804-2.803a.856.856 0 011.21 0l2.803 2.803a.856.856 0 010 1.21l-2.803 2.803a.856.856 0 01-1.21 0L110 159.047a.856.856 0 010-1.21zM22.249 33.74l3.551-3.553a1.1 1.1 0 011.556 0l3.552 3.552a1.1 1.1 0 010 1.557l-3.551 3.551a1.1 1.1 0 01-1.556 0l-3.552-3.551a1.1 1.1 0 010-1.557zM148.715 132l3.551-3.553a1.1 1.1 0 011.556 0l3.552 3.552a1.1 1.1 0 010 1.557l-3.551 3.551a1.1 1.1 0 01-1.556 0l-3.552-3.551a1.1 1.1 0 010-1.557z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(.693 29.562)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#error-data_svg__a)",
  d: "M89.949 0a2.62 2.62 0 012.62 2.621c0 1.334-1 2.45-2.366 2.608l-.254.013h-3.401l.001 8.766c19.212 1.344 34.38 17.355 34.38 36.909 0 20.435-16.566 37-37 37-20.436 0-37.001-16.565-37.001-37 0-19.554 15.168-35.565 34.38-36.91l-.003-8.766-3.397.001a2.622 2.622 0 01-2.609-2.369l-.012-.252c0-1.334 1.001-2.45 2.367-2.608L77.908 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#error-data_svg__b)",
  d: "M41.882 62.032a1.748 1.748 0 01.204 3.483l-.204.011H9.392a1.747 1.747 0 01-.204-3.483l.204-.011h32.49zM11.303 50.564a1.749 1.749 0 01.204 3.483l-.204.012H1.747a1.746 1.746 0 01-.203-3.483l.203-.012h9.556zm40.135 0a1.749 1.749 0 01.204 3.483l-.204.012h-32.49a1.747 1.747 0 01-.204-3.483l.204-.012h32.49zm9.556-11.467a1.748 1.748 0 01.204 3.483l-.204.012h-32.49a1.747 1.747 0 01-.204-3.483l.204-.012h32.49zm-40.135 0a1.749 1.749 0 01.204 3.483l-.204.012h-9.556a1.747 1.747 0 01-.203-3.483l.203-.012h9.556z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83.928,
  cy: 50.917,
  r: 13.875,
  fill: "url(#error-data_svg__c)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#error-data_svg__d)",
  d: "M96.327 35.798a1.747 1.747 0 012.638 2.283l-.144.166L85.175 52.14a1.746 1.746 0 01-2.637-2.283l.144-.166 13.645-13.894z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#error-data_svg__e)",
  fillRule: "nonzero",
  d: "M83.773 80.287c.893 0 1.629.67 1.73 1.532l.01.202v5.252c0 .957-.778 1.734-1.74 1.734a1.74 1.74 0 01-1.729-1.532l-.011-.202v-5.252c0-.958.779-1.734 1.74-1.734zm23.398-8.851l.164.144 3.731 3.716c.68.677.68 1.775 0 2.452a1.745 1.745 0 01-2.297.144l-.164-.144-3.732-3.716a1.729 1.729 0 010-2.452 1.746 1.746 0 012.298-.144zm-44.498.144c.628.625.676 1.608.145 2.288l-.145.164-3.731 3.716a1.746 1.746 0 01-2.462 0 1.729 1.729 0 01-.145-2.288l.145-.164 3.732-3.716a1.745 1.745 0 012.461 0zm57.957-22.75c.961 0 1.74.777 1.74 1.734 0 .89-.672 1.622-1.537 1.722l-.203.012h-5.274c-.96 0-1.74-.776-1.74-1.734 0-.889.672-1.621 1.537-1.721l.203-.012h5.274zm-11.016-25.699c.646.646.696 1.662.15 2.365l-.15.169-5.154 5.154a1.792 1.792 0 01-2.683-2.365l.15-.169 5.153-5.154c.7-.7 1.834-.7 2.534 0zm-50.836.106l.164.144 3.731 3.716c.68.677.68 1.775 0 2.452a1.745 1.745 0 01-2.297.144l-.164-.144-3.732-3.716a1.729 1.729 0 010-2.452 1.746 1.746 0 012.298-.144zm24.995-11.115c.893 0 1.629.67 1.73 1.532l.01.202v5.252c0 .958-.778 1.734-1.74 1.734a1.74 1.74 0 01-1.729-1.532l-.011-.202v-5.252c0-.957.779-1.734 1.74-1.734z"
})));

function SvgErrorData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167,
    height: 164
  }, props), _ref, _ref2);
}

export default SvgErrorData;